const appSettingsReducer = (state = [], action = {}) => {
    switch (action.type) {
    case 'DOMAINS_BASED_ON_LANG_SUCCESS':
        return action.payload;
    default:
        return state;
    }
};

export default appSettingsReducer;
